import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonService } from '../common_services/common.service';
import { config } from 'src/assets/config';
import { EncryptionService } from '../common_services/encryption.service';


@Injectable({
  providedIn: 'root'
})
export class AutheticationService {

  apiToken: string;

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private encryptionService: EncryptionService
    ) {

  }

  

  login() {
    const data = 'grant_type=' + environment.token_grant_type
       + '&username=' + config.username
        + '&password=' + config.password
      + '&client_id=' + environment.token_client_id
      + '&client_secret=' + this.encryptionService.encryptText(environment.token_client_secret);
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }) };

    return this.http.post<any>(config.apiHostClient + config.apiURL + '/FOToken', data, options)
      .pipe(map(x => {
       this.commonService.setLocalStorage('token', x);
      })).catch(this.handleError);
  }


  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}` + error.error.message);
    }
    const data = JSON.parse(error.error.error);
    return throwError(data.Errors[0].Message);
  }
}
